import { updateAnswer } from 'components/question/actions'
import { takeEvery } from 'redux-saga/effects'
import { moveToNextScreen } from '../../sagas/moveToNextScreen'

export function* watchForQuestionActions() {
  yield takeEvery(updateAnswer.toString(), moveToNextScreen)
}
